"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@fluentui/react");
var clsx_1 = __importDefault(require("clsx"));
var react_2 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var mapStateToProps = function (state) { return ({
    currentLanguage: state.reduxlanguage.language,
}); };
var mapDispatchToProps = {};
var connector = react_redux_1.connect(mapStateToProps, mapDispatchToProps);
var CustomComBoBox = function (props) {
    var className = props.className, currentLanguage = props.currentLanguage;
    // eslint-disable-next-line react/jsx-props-no-spreading
    return (react_2.default.createElement(react_1.ComboBox, __assign({}, props, { label: undefined, required: undefined, className: clsx_1.default(className, currentLanguage.isRtl ? 'rtlFlag' : '') })));
};
exports.default = connector(CustomComBoBox);
//# sourceMappingURL=CustomComboBox.js.map